<template>
  <v-card>
    <v-card-title class="pr-2" :style=" { backgroundColor: companyPrimaryColor }">
      <h2 style="color:white">Locatie toevoegen</h2>
      <v-spacer></v-spacer>
      <v-btn icon dark @click="closeAddBranchDialog()">
        <v-icon dark color="white">close</v-icon>
      </v-btn>
    </v-card-title>

    <v-alert
      class="pa-1 ma-0"
      v-if="feedback"
      :value="true"
      type="warning"
      >
      {{ feedback }} 
    </v-alert>

    <v-divider></v-divider>

    <v-card-text class="pa-0">
      <v-form  ref="AddBranchForm" lazy-validation>

        <v-container  grid-list-md fluid class="ma-0 pa-3">
          <v-layout row wrap>
            <v-flex xs12 >
              <v-text-field
                label="Naam"
                v-model="newBranch.name"
                :rules="requiredRules"
                :color="companyPrimaryColor"
                background-color="background"
                hide-details
                outlined
                required
              ></v-text-field>
            </v-flex>
          
            <v-flex xs12 sm6 md9>
              <v-text-field
                class="pt-2"
                label="Adres"
                v-model="newBranch.address"
                :color="companyPrimaryColor"
                background-color="background"
                hide-details
                outlined
                required
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 md3>
              <v-text-field
                class="pt-2"
                label="huisnummer"
                v-model="newBranch.number"
                :color="companyPrimaryColor"
                background-color="background"
                hide-details
                outlined
                required
                ></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 md3>
              <v-text-field
                class="pt-2"
                label="Postcode"
                v-model="newBranch.postalCode"
                background-color="background"
                :color="companyPrimaryColor"
                hide-details
                outlined
                required
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 md9>
              <v-text-field
                class="pt-2"
                label="Plaats"
                v-model="newBranch.city"
                background-color="background"
                :color="companyPrimaryColor"
                hide-details
                outlined
                required
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 md6>
              <v-text-field
                class="pt-2"
                label="Provincie"
                v-model.trim="newBranch.province"
                background-color="background"
                :color="companyPrimaryColor"
                outlined
                hide-details
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md6>
              <v-text-field
                class="pt-2"
                label="Land"
                v-model.trim="newBranch.country"
                background-color="background"
                :color="companyPrimaryColor"
                outlined
                hide-details
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md6>
              <v-text-field
                class="pt-2"
                label="Telefoonnummer"
                v-model="newBranch.phonenumber"
                background-color="background"
                :color="companyPrimaryColor"
                outlined
                hide-details
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md6>
              <v-text-field
                class="pt-2"
                label="E-mailadres"
                v-model="newBranch.email"
                background-color="background"
                :color="companyPrimaryColor"
                hide-details
                outlined
                required
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>

      </v-form>
    </v-card-text>

    <v-divider></v-divider>

    <v-card-actions>
      <v-container grid-list-md fluid class="ma-0 pa-0">
        <v-layout row wrap class="ma-0 pa-0">
          <v-flex xs12 md6 class="text-left" v-if="$vuetify.breakpoint.name != 'sm' && $vuetify.breakpoint.name != 'xs'">
            <v-btn
              outlined
              depressed
              color="primary"
              @click="closeAddBranchDialog()"
              >
              Annuleren
            </v-btn>
          </v-flex>
          <v-flex xs12 md6 class="text-right">
            <v-btn
              v-if="busy == false"
              dark
              rounded
              :block="$vuetify.breakpoint.name == 'sm' || $vuetify.breakpoint.name == 'xs'"
              :color="companySecondaryColor"
              @click="addBranch()"
              >
              Locatie toevoegen
              <v-icon right dark>chevron_right</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-actions>

  </v-card>
</template>


<script>
import slugify from "slugify";
import db from "../../firebase/init";
import firebase from "firebase/app";
import platform from 'platform'; 

export default {
  name: "add-branch-form",
  props: {
    activeCompData: Object
  },
  data() {
    return {
      panel: [0],
      newBranch: {
        name: null,
        address: null,
        number: null,
        postalCode: null,
        city: null,
        province: null,
        country: null,
        phonenumber:null,
        email:null,
      },
      requiredRules: [v => !!v || "Dit veld is verplicht"],
      showNewDialog: false,
      feedback: null,
      errors: [],
      busy: false,

    };
  },

  methods: {
    closeAddBranchDialog() {
      this.$emit("newBranchDialogChange", false);
      this.feedback = null;
    },

    addBranch() {
      if (this.$refs.AddBranchForm.validate()) {
        this.busy = true;
        let branchName = this.activeCompData.id + this.newBranch.name;
        let branchNameLower = branchName.toLowerCase();
        let branchNameLowerNoSpecial = branchNameLower.replace(/[!@#$%^&*+()"';:.,]+/g, "");
        this.brancheId = branchNameLowerNoSpecial.replace(/\s+/g, "");

        db.collection("branches")
          .doc()
          .set({
            compId: this.activeCompData.id,
            branchName: this.newBranch.name,
            address: this.newBranch.address,
            number: this.newBranch.number,
            postalCode: this.newBranch.postalCode,
            city: this.newBranch.city,
            province: this.newBranch.province,
            country: this.newBranch.country,
            phonenumber: this.newBranch.phonenumber,
            email: this.newBranch.email,
          })
          .then(() => {
            db.collection("log")
              .add({
                time: new Date(),
                logType: "info",
                user: this.userFirstName + " " + this.userLastName,
                userType: this.userRole,
                company: this.userCompany,
                actionType: "User Action",
                software: String(platform.os),
                browser: platform.name + " " + platform.version, 
                action: "Nieuwe locatie toegevoegd: " + this.activeCompData.name,
                extra:
                  "<b>Naam:</b> " +
                  this.newBranch.name +
                  "<br>" +
                  "<b>Straat:</b> " +
                  this.newBranch.address +
                  "<br>" +
                  "<b>Huisnummer:</b> " +
                  this.newBranch.number +
                  "<br>" +
                  "<b>Postcode:</b> " +
                  this.newBranch.postalCode +
                  "<br>" +
                  "<b>Plaats:</b> " +
                  this.newBranch.city +
                  "<br>" +
                  "<b>Provincie:</b> " +
                  this.newBranch.province +
                  "<br>" +
                  "<b>Land:</b> " +
                  this.newBranch.country
              })
              .catch(error => {
                console.error("Error logging new branch: ", error);
              });
          })
          .then(() => {
            this.$emit("updateData");
            this.closeAddBranchDialog();
            this.$refs.AddBranchForm.reset();
            this.busy = false;
            console.log("Branch succesfully added");
          })
          .catch(error => {
            this.busy = false;
            console.error("Error adding Branch: ", error);
            db.collection("log").add({
              time: new Date(),
              logType: "error",
              user: this.userFirstName + " " + this.userLastName,
              userType: this.userRole,
              company: this.userCompany,
              actionType: "User Action",
              action: "Error adding Branch: " + this.activeCompName,
              extra: JSON.stringify(error)
            });
          });
      } else {
        this.feedback = "Vul alle velden in om een locatie toe te voegen.";
      }
    }
  },

  computed: {
    userCompanies() {
      return this.$store.state.userCompanies;
    },
    userCompany() {
      return this.$store.state.userCompany;
    },
    userFirstName() {
      return this.$store.state.userFirstName;
    },
    userLastName() {
      return this.$store.state.userLastName;
    },
    userRole() {
      return this.$store.state.userRole;
    },
    companyPrimaryColor() {
      return this.$store.state.companyPrimaryColor;
    },
    companySecondaryColor() {
      return this.$store.state.companySecondaryColor;
    },
    theme(){
      return (this.$vuetify.theme.dark) ? 'dark' : 'light'
    }
  }
};
</script>
